/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Warning Icon component - drawn
 * in Red by default; pass `color` to recolor it (e.g. the DLS History &
 * Timeline Modes Error Tag's orange warning).
 */
export const WarningIcon = (props: IconProps) => {
  const {iconSize} = useIconDLS(props);
  const stroke     = (props.color as string) || dlsColor('caRed');
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M12.4285 2.75311C12.2362 2.41896 11.754 2.41906 11.5617 2.75328L1.43093 20.3682C1.23922 20.7015 1.47983 21.1174 1.86436 21.1174H22.1352C22.5199 21.1174 22.7605 20.7013 22.5686 20.368L12.4285 2.75311Z' stroke={stroke} strokeWidth='1.5' strokeMiterlimit='10'/>
      <path d='M11.9932 8.64062V15.0198' stroke={stroke} strokeWidth='1.5' strokeMiterlimit='10'/>
      <path d='M11.9932 16.1699V17.9335' stroke={stroke} strokeWidth='1.5' strokeMiterlimit='10'/>
    </svg>
  );
};
